import React from 'react';

import Text from './index';

export default (props) => (
    <Text {...props} style={[{ fontSize: 11 }, props.style]}>
        {props.children}
    </Text>
);
